import React, { FC } from 'react';
import { Link } from 'react-router-dom';

/** The rules in five lines (accurate to the README / engine). */
export const HowToPlaySteps: FC = () => (
  <ol className="st-steps">
    <li>
      <span className="st-steps__glyph" aria-hidden="true">
        ♠
      </span>
      <span>
        <strong>Ace of spades opens.</strong> Whoever holds it starts the game,
        and everyone plays a spade.
      </span>
    </li>
    <li>
      <span className="st-steps__glyph" aria-hidden="true">
        ♣
      </span>
      <span>
        <strong>Follow suit if you can.</strong> The highest card of the led
        suit (A, K, Q, J … 2) clears the round and leads the next one.
      </span>
    </li>
    <li>
      <span className="st-steps__glyph" aria-hidden="true">
        ♦
      </span>
      <span>
        <strong>Out of that suit? Throw anything.</strong> But breaking suit is
        a <em>thoka</em>: the whole pile goes to whoever played the highest card
        of the led suit.
      </span>
    </li>
    <li>
      <span className="st-steps__glyph" aria-hidden="true">
        ♥
      </span>
      <span>
        <strong>Empty your hand to escape.</strong> The last player still
        holding cards is the <strong>Bhabi</strong>.
      </span>
    </li>
  </ol>
);

export const HowToPlay: FC<{ showFullRulesLink?: boolean }> = ({
  showFullRulesLink = true,
}) => (
  <section className="st-stack" aria-labelledby="how-to-play-title">
    <h2 id="how-to-play-title" className="st-h3">
      How to play
    </h2>
    <HowToPlaySteps />
    {showFullRulesLink && (
      <p className="st-small st-muted">
        <Link className="st-link" to="/game-rules">
          Read the full rules
        </Link>
      </p>
    )}
  </section>
);
